import { BaseIcon } from './Base';
import { CustomSvgIconProps, IconType } from './constants';

export const MarshMcLennanIcon = ({
  width = '280px',
  height = '25px',
  variant = IconType.Light,
}: CustomSvgIconProps) => (
  <BaseIcon
    src={'../../public/marshMcLennanLogo.svg'}
    alt="Marsh McLennan icon"
    width={width}
    height={height}
    variant={variant}
  />
);
